import types from '../actions/types';
const initialState = {};

export default function stagesReducer(state = initialState, action) {
    switch (action.type) {
        case types.TOGGLE_DISTANCE_MODAL:
            return {
                ...state,
                distance_modal: action.payload.toggle,
                distance: action.payload.distance
            };

        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/js/reducers/distance.js